import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

import { Tooltip } from '../../../../ui/tooltip';
import toolTipStyles from '../../../../ui/tooltip/Tooltip.module.css';
import { TSpendingLimitType } from '../../hooks/useGetSpendingLimits';
import { mapSellerProductToDurationInMonths } from '../../OfferChoiceForm/utils/mapSellerProductToDuration';
import { formatDuration } from '../../spendingLimitCard/components/formatDuration';
import styles from '../SpendingLimitDrawer.module.css';

export const UnavailableLimit = ({
    sellerProduct
}: {
    sellerProduct: TSpendingLimitType;
}) => {
    const durationInMonths = mapSellerProductToDurationInMonths({
        sellerProduct: sellerProduct
    });

    return (
        <div>
            <div className={styles.loanDuration}>
                {formatDuration({ duration: durationInMonths! })} purchases
            </div>
            <div className={styles.leftToSpend}>Left to spend:</div>
            <div className={styles.creditLimit}>
                <FormattedCurrency className={styles.creditLimit} value={0} />
                <Tooltip
                    variant="primary"
                    className={toolTipStyles.TooltipRight}
                    message="We can’t approve you for more funds right now - check back in 30 days and hit ‘Secure my limit’."
                />
            </div>
        </div>
    );
};
